var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "store-authorize-tip",
      class: { "lang-en": ["en_US", "ko_KR"].includes(_vm.currentLang) }
    },
    [
      _c("div", { staticClass: "tip-mask" }),
      _c(
        "div",
        {
          staticClass: "tip-main",
          style: {
            transform:
              "translate(-50%, calc(-50% - " +
              40 * _vm.scale +
              "px)) scale(" +
              _vm.scale +
              ")"
          }
        },
        [
          _c("div", { staticClass: "tip-main__logo" }, [
            _c("img", { attrs: { src: _vm.logoImg[_vm.currentLang], alt: "" } })
          ]),
          _c("div", { staticClass: "tip-main__title" }, [
            _vm._v(_vm._s(_vm.$t("store-tip.title")))
          ]),
          _c("div", { staticClass: "tip-main__subtitle" }, [
            _c("span", [
              _c("i", { staticStyle: { left: "-20px" } }),
              _vm._v(" " + _vm._s(_vm.$t("store-tip.subtitle")) + " "),
              _c("i", { staticStyle: { right: "-20px" } })
            ])
          ]),
          _c("div", { staticClass: "tip-main__guide" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("store-tip.guide")))])
          ]),
          _c(
            "ul",
            { staticClass: "tip-main__funs" },
            _vm._l(_vm.func, function(i) {
              return _c("li", { key: i.name }, [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "iconfont", class: i.icon })
                ]),
                _c("div", {
                  staticClass: "info",
                  domProps: { innerHTML: _vm._s(_vm.$t(i.name)) }
                })
              ])
            }),
            0
          ),
          _c(
            "a-checkbox",
            {
              staticClass: "tip-main__remind",
              model: {
                value: _vm.notremind,
                callback: function($$v) {
                  _vm.notremind = $$v
                },
                expression: "notremind"
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("store-tip.remind")) + " ")]
          ),
          _c(
            "div",
            { staticClass: "tip-main__btn", on: { click: _vm.toAuth } },
            [_vm._v(_vm._s(_vm.$t("store-tip.btn")))]
          ),
          _c(
            "div",
            { staticClass: "tip-main__close", on: { click: _vm.handleClose } },
            [_c("icon-font", { attrs: { type: "gb-icon-guanbi1" } })],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }